import { render, staticRenderFns } from "./TopicResponseBox.vue?vue&type=template&id=fa72c5d6&scoped=true"
import script from "./TopicResponseBox.vue?vue&type=script&lang=js"
export * from "./TopicResponseBox.vue?vue&type=script&lang=js"
import style0 from "./TopicResponseBox.vue?vue&type=style&index=0&id=fa72c5d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa72c5d6",
  null
  
)

export default component.exports